import {
	NgModule,
	Optional,
	SkipSelf,
	ModuleWithProviders
} from "@angular/core";
import { LocalStorageConfig } from "./trycatch-local-store.config";
import { LocalStorageService } from "./trycatch-local-storage.service";

@NgModule({
	providers: [LocalStorageService]
})
export class TryCatchLocalStorageModule {
	constructor(
		@Optional()
		@SkipSelf()
		parentModule: TryCatchLocalStorageModule
	) {
		if (parentModule) {
			throw new Error(
				"TryCatch Local Stroage Module is already loaded. Import it in the AppModule only"
			);
		}
	}

	static forRoot(config: TryCatchLocalStorageModule): ModuleWithProviders<TryCatchLocalStorageModule> {
		return {
			ngModule: TryCatchLocalStorageModule,
			providers: [
				{ provide: LocalStorageConfig, useValue: config },
				LocalStorageService
			]
		};
	}
}
